/**
 * Calendar utilities — generate "Add to Google Calendar" URLs and trigger
 * .ics downloads from the backend.
 *
 * Google Calendar format:
 *   https://www.google.com/calendar/render?action=TEMPLATE
 *     &text=Title
 *     &dates=YYYYMMDDTHHMMSSZ/YYYYMMDDTHHMMSSZ
 *     &details=Description
 *     &location=Location
 */

const pad = (n) => String(n).padStart(2, "0");

/** Format JS Date as YYYYMMDDTHHMMSSZ (UTC). */
function toGcalDate(d) {
    return (
        d.getUTCFullYear() +
        pad(d.getUTCMonth() + 1) +
        pad(d.getUTCDate()) +
        "T" +
        pad(d.getUTCHours()) +
        pad(d.getUTCMinutes()) +
        pad(d.getUTCSeconds()) +
        "Z"
    );
}

/** Best-effort parse of an ISO string (or YYYY-MM-DD date). */
export function parseDateMaybe(value) {
    if (!value) return null;
    // Date-only (YYYY-MM-DD) → midday UTC to avoid TZ shifts.
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return new Date(value + "T12:00:00Z");
    }
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
}

/**
 * Build a Google Calendar "Add event" URL.
 * `start` / `end` are JS Date objects (UTC). If missing, defaults to now + 1h.
 */
export function buildGoogleCalendarUrl({ title, description = "", location = "", start, end }) {
    const now = new Date();
    const s = start || new Date(now.getTime() + 60 * 60 * 1000);
    const e = end && end > s ? end : new Date(s.getTime() + 60 * 60 * 1000);
    const params = new URLSearchParams({
        action: "TEMPLATE",
        text: title || "",
        dates: `${toGcalDate(s)}/${toGcalDate(e)}`,
        details: description || "",
        location: location || "",
    });
    return `https://www.google.com/calendar/render?${params.toString()}`;
}
